import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaundromatOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M13 10.5a2.5 2.5 0 0 1 5 0c0 .701-.156 1.023-.393 1.271-.303.317-.84.621-1.866 1.05a2.015 2.015 0 0 0-1.241 1.856v1.311l.001.06a1 1 0 0 0 .514.827L27.286 24H4.507l8.298-5.15a1 1 0 1 0-1.054-1.7L3.453 22.3c-1.71 1.062-.958 3.7 1.054 3.7h22.78c2.043 0 2.77-2.703 1.004-3.73L16.5 15.424v-.748a.03.03 0 0 1 .014-.01c1.015-.425 1.915-.861 2.538-1.512.688-.72.948-1.593.948-2.654a4.5 4.5 0 1 0-9 0 1 1 0 1 0 2 0" />
  </svg>
);
const ForwardRef = forwardRef(IconLaundromatOutlineSVG);
ForwardRef.displayName = "IconLaundromatOutline";
export { ForwardRef as IconLaundromatOutline };
